import {ErrorDtoFactory, FlyerDto, UploadProgressingImagesDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as FlyerFromPdfActions} from "../actions/flyerFromPdfActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";
import {Action as ProgressPopupActions} from "../actions/uploadingImagesProgressActions";
import {
    DefaultFlyerStateForSelfService
} from "../../components/flippingFlyersCatalog/flippingFlyersCatalogCreateEditFlyer";
import {FlyersState} from "../reducers/flyersReducer";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {Action as FlyersActions} from "../actions/flyersActions";

export const createFlyerFromPdfFile = (
    file: File,
    isForPreview: boolean = false,
    flyersState?: FlyersState
) => {
    let userDtoStr = localStorage.getItem("userDto");
    if(isForPreview){
        userDtoStr = localStorage.getItem("userDtoForPreview");
    }
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlyerFromPdfActions | ProgressPopupActions | FlyerDetailsActions | FlyersActions>
    ) => {
        dispatch({
            type: ActionType.CREATE_FLYER_FROM_PDF_START,
        });

        try {
            let result: any = await createFlyerFromPdfFileRequest(
                file,
                isForPreview,
                dispatch
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data.flyer;
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_PDF_SUCCESS,
                payload: flyer.flyRecId,
            });
            // dispatch({
            //     type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
            //     payload: flyer,
            // });
            if(flyersState){
                const flyersStatePayload: FlyersState = {
                    ...flyersState,
                    flyers: [flyer, ...flyersState.flyers],
                };
                dispatch({
                    type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                    payload: flyer,
                });

                dispatch({
                    type: ActionType.CHANGE_FLYERS_STATE,
                    payload: flyersStatePayload,
                });
            }
            localStorage.removeItem(`userEnterForFirstTime${userDto.userId}`);
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_PDF_COMPLETED
            });
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR
            })
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_PDF_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


const createFlyerFromPdfFileRequest = (
    file: File,
    isForPreview: boolean,
    dispatch: Dispatch<FlyerFromPdfActions | ProgressPopupActions>
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            if(isForPreview){
                userDtoStr = localStorage.getItem("userDtoForPreview");
            }
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            formData.append(`Pdf`, file, file.name);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
                onUploadProgress: (progressEvent : any) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    // console.log(percentCompleted);
                    const data: UploadProgressingImagesDto = {
                        isUploadingFilesToSystem: progressEvent.loaded !== progressEvent.total,
                        isUploadingFilesToSystemFinished: progressEvent.loaded === progressEvent.total,
                        current: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.loaded,
                        failCount: 0,
                        processingFinished: false,
                        successCount: 0,
                        severityLevel: '',
                        total: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.total,
                        titlePopup: `Uploading file...`,
                        notUploadedImages: null,
                    }
                    dispatch({
                        type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
                        payload: data
                    });
                },

            };
            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/CreateFlyerFromPdf`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};


export const updateFlipbook = (
    data: DefaultFlyerStateForSelfService,
    flyersState: FlyersState,
) => {
/*
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);
*/

    return async (
        dispatch: Dispatch<FlyerFromPdfActions | ProgressPopupActions | FlyerDetailsActions | FlyersActions>
    ) => {
        dispatch({
            type: ActionType.UPDATE_FLIPBOOK_START,
        });

        try {
            let result: any = await updateFlipbookRequest(
                data,
                dispatch
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data.flyer;
            dispatch({
                type: ActionType.UPDATE_FLIPBOOK_SUCCESS,
                payload: flyer.flyRecId,
            });
            // dispatch({
            //     type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
            //     payload: flyer,
            // });
            const flyers: FlyerDto[] = flyersState.flyers.map((key: FlyerDto) => {
                if (data.flyerId === key.flyRecId) {
                    return flyer;
                } else {
                    return key;
                }
            });
            const flyersStatePayload: FlyersState = {
                ...flyersState,
                flyers: [...flyers],
            };
            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: flyer,
            });

            dispatch({
                type: ActionType.CHANGE_FLYERS_STATE,
                payload: flyersStatePayload,
            });

            dispatch({
                type: ActionType.UPDATE_FLIPBOOK_COMPLETED
            });
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR
            })
            dispatch({
                type: ActionType.UPDATE_FLIPBOOK_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


const updateFlipbookRequest = (
    data: DefaultFlyerStateForSelfService,
    dispatch: Dispatch<FlyerFromPdfActions | ProgressPopupActions>
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);

            const formData = new FormData();
            const newData: any = {
                displayCaption: data.displayCaption!,
                caption: data.caption!,
                primaryColorRgb: data.guiColor!,
                flyerId: data.flyerId!.toString(),
                font: data.fontFamily!,
                flyerStatusCode: data.flyerStatusCode!,
                iconContrast: data.iconStyle?.iconStyleType,
                urls: {
                    accountHomePageUrl: data.homePage
                }
            };
            // formData.append(`DisplayCaption`, data.displayCaption!);
            // formData.append(`Caption`, data.caption!);
            // formData.append(`PrimaryColorRgb`, data.guiColor!);
            if(data.startDate){
                newData.validFromUtc = new Date(
                    data.startDate?.getTime() -
                    data.startDate?.getTimezoneOffset() * 60000
                ).toJSON();
            }
            // if(data.startDate){
            //     const parseStartData = new Date(
            //         data.startDate?.getTime() -
            //         data.startDate?.getTimezoneOffset() * 60000
            //     ).toJSON();
            //     formData.append(`ValidFromUtc`, parseStartData);
            // }
            if(data.endDate){
                newData.validToUtc = new Date(
                    data.endDate?.getTime() -
                    data.endDate?.getTimezoneOffset() * 60000
                ).toJSON();
            }
            // if(data.endDate){
            //     const parseEndData = new Date(
            //         data.endDate?.getTime() -
            //         data.endDate?.getTimezoneOffset() * 60000
            //     ).toJSON();
            //     formData.append(`ValidToUtc`, parseEndData);
            // }
            if((!data.bgImageFile && !data.bgImage) || data.bgColor){
                newData.backgroundColorRgb = data.bgColor!;
            }
            // if((!data.bgImageFile && !data.bgImage) || data.bgColor){
            //     formData.append(`backgroundColorRgb`, data.bgColor!);
            // }
            if(data.language?.id){
                newData.languageCultureId = data.language.id.toString();
                // formData.append(`LanguageCultureId`, data.language.id.toString());
            }

            if(data.logoFile){
                formData.append(`GuiLogo`, data.logoFile, data.logoFile.name);
            }
            if(data.bgImageFile && data.bgImage){
                formData.append(`GuiBackgroudImage`, data.bgImageFile, data.bgImageFile.name);
                newData.backgroundColorRgb = "";
            }
            if(data.pdfFile){
                formData.append(`Pdf`, data.pdfFile, data.pdfFile.name);
            }
            // if(data.bgImageFile && data.bgImage){
            //     formData.append(`GuiBackgroudImage`, data.bgImageFile, data.bgImageFile.name);
            //     formData.append(`backgroundColorRgb`, ``);
            // }

            // formData.append(`FlyerId`, data.flyerId!.toString());
            // formData.append(`Font`, data.fontFamily!);
            // formData.append(`FlyerStatusCode`
            // console.log(JSON.stringify(newData));
            formData.append("UpdateSelfServiceFlyerData", JSON.stringify(newData));
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
                onUploadProgress: (progressEvent : any) => {
                    if(data.pdfFile && data.pdfFile.name){
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        const newData: UploadProgressingImagesDto = {
                            isUploadingFilesToSystem: progressEvent.loaded !== progressEvent.total,
                            isUploadingFilesToSystemFinished: progressEvent.loaded === progressEvent.total,
                            current: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.loaded,
                            failCount: 0,
                            processingFinished: false,
                            successCount: 0,
                            severityLevel: '',
                            total: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.total,
                            titlePopup: `Uploading file...`,
                            notUploadedImages: null,
                        }
                        dispatch({
                            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
                            payload: newData
                        });
                    }
                },
            };
            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/UpdateSelfServiceFlyer`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};
